import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MdDownloadForOffline } from "react-icons/md";
import config from "../config";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";

function IntermediateLanding() {
  const navigate = useNavigate();
  const [notices, setNotices] = useState([]);
  const [tickerData, setTickerData] = useState({});
  const [fileSizes, setFileSizes] = useState({});

  const SECRET_KEY = config.SECRET_KEY;
  function generateOneTimeToken() {
    const timestamp = Date.now();
    const nonce = CryptoJS.lib.WordArray.random(16).toString();
    const payload = `${timestamp}:${nonce}`;
    const signature = CryptoJS.HmacSHA256(payload, SECRET_KEY).toString();

    return `${timestamp}:${nonce}:${signature}`;
  }

  const fetchData = async () => {
    try {
      const tokeng = generateOneTimeToken();
      const response = await fetch(
        `${config.API_BASE_URL}/AdminFetchLandingPageDataIntermediate`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Private-Key": tokeng,
          },
        }
      );

      const data = await response.json();
      if (response.ok) {
        setNotices(data.data.notice_details || []);
        setTickerData(data.data.titleDetails || {});
      }
    } catch (error) {
      console.error("Error fetching school:", error);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/assets/css/landing.css";
    document.head.appendChild(link);

    fetchData();

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  useEffect(() => {
    const fetchFileSizesSequentially = async () => {
      const sizes = {};

      for (let index = 0; index < notices.length; index++) {
        const notice = notices[index];

        if (notice.NOTICE_FILE_URL) {
          try {
            const response = await fetch(notice.NOTICE_FILE_URL, {
              method: "HEAD",
            });
            const size = response.headers.get("Content-Length");
            sizes[index] = size ? (parseInt(size) / 1024).toFixed(2) : "0.00";
          } catch (err) {
            console.error(`Error fetching size for notice ${index}:`, err);
            sizes[index] = "0.00";
          }
        } else {
          sizes[index] = "0.00";
        }
      }

      setFileSizes(sizes);
    };

    if (Array.isArray(notices)) {
      fetchFileSizesSequentially();
    } else {
      console.warn("Notices is not a valid array:", notices);
      setFileSizes({});
    }
  }, [notices]);
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <div style={{ flex: "1" }}>
        <header id="header">
          <div
            className="background"
            style={{
              height: 340,
              backgroundImage: "url(assets/images/jac-banner-1.jpg)",
              backgroundPosition: "center",
              backgroundSize: "cover",
              position: "relative",
            }}
          >
            <div className="container">
              <div
                style={{ display: "flex", paddingTop: 130 }}
                className="logo-div"
              >
                <div>
                  <img
                    alt="no preview"
                    className="logo-img"
                    src="assets/images/jac.png"
                    height="120px"
                    style={{ marginRight: 30 }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <h1 className="jac-text" style={{ color: "white" }}>
                    Jharkhand Academic Council
                  </h1>
                  <h4 className="exam-text" style={{ color: "white" }}>
                    Intermediate Registration & Examination Portal
                  </h4>
                </div>
              </div>
            </div>
            {tickerData.title && (
              <div
                style={{ position: "absolute", bottom: "30px", width: "100%" }}
              >
                <div
                  className="header"
                  style={{ width: "63%", marginLeft: "5%" }}
                >
                  <marquee
                    className="marq"
                    direction="left"
                    style={{
                      color: "white",
                      fontWeight: 500,
                      padding: 10,
                      borderRadius: 10,
                      fontSize: 20,
                    }}
                  >
                    {tickerData.title}
                  </marquee>
                </div>
              </div>
            )}
          </div>
        </header>

        {/* <nav className="navbar">
        <div className="navbar-container container">
          <div>
            <input type="checkbox" />
            <div className="hamburger-lines">
              <span className="line line1" />
              <span className="line line2" />
              <span className="line line3" />
            </div>
            <ul className="menu-items">
              <li>
                <a href="#" id="home-link" className="active">
                  Home
                </a>
              </li>

              <li>
                <a href="#" id="contact-link">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav> */}

        <div className="container">
          <div className="testimonial-slider">
            <div
              id="carouselExampleControls"
              className="carousel carousel-dark"
            >
              <div className="container-fluid">
                <div className="row mb-5">
                  <h2 style={{ color: "black" }}>Service Portals</h2>
                  <hr></hr>
                  {/* <div className="col-md-3">
                  <div style={{ marginTop: "15px", marginLeft: "10px" }}></div>
                  <a
                    style={{
                      height: "100px",
                      fontSize: "18px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    className="btn mb-3 landing-button2"
                    href="https://board-eleven.jacexamonline.com"
                  >
                    Class XI<br></br> Registration Portal
                  </a>
                </div> */}
                 <div className="col-md-3">
                    <div
                      style={{ marginTop: "15px", marginLeft: "10px" }}
                    ></div>
                    <a
                      href="https://jacexamportal.in/notice.html"
                      style={{
                        height: "100px",
                        fontSize: "18px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                      className="btn mb-3 landing-button2"
                      // onClick={() => navigate("/class-xii")}
                    >
                     Download <br></br>Examination Forms
                    </a>
                  </div>
                   <div className="col-md-3">
                    <div
                      style={{ marginTop: "15px", marginLeft: "10px" }}
                    ></div>
                    <a
                      href="https://board-eleven.jacexamonline.com"
                      style={{
                        height: "100px",
                        fontSize: "18px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                      className="btn mb-3 landing-button2"
                      // onClick={() => navigate("/class-xii")}
                    >
                     PORTAL FOR CLASS 11 <br></br>(INTERMEDIATE)<br></br> REGISTRATION 2026
                    </a>
                  </div>
                  <div className="col-md-3">
                    <div
                      style={{ marginTop: "15px", marginLeft: "10px" }}
                    ></div>
                    <a
                      href=" https://board-twelve.jacexamonline.com"
                      style={{
                        height: "100px",
                        fontSize: "18px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                      className="btn mb-3 landing-button2"
                      // onClick={() => navigate("/class-xii")}
                    >
                     PORTAL FOR CLASS 12 <br></br>(INTERMEDIATE)<br></br> EXAMINATION 2026
                    </a>
                  </div>
                     <div className="col-md-3">
                    <div
                      style={{ marginTop: "15px", marginLeft: "10px" }}
                    ></div>
                    <a
                      href="https://intermediate-correction-portal.jacexamonline.com"
                      style={{
                        height: "100px",
                        fontSize: "18px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                      className="btn mb-3 landing-button2"
                      // onClick={() => navigate("/class-xii")}
                    >
                     CLASS 12 STUDENT DATA <br></br>CORRECTION PORTAL
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer
        style={{ padding: 10, backgroundColor: "#00a65a", color: "white" }}
      >
        <div
          className="container"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <p style={{ marginBottom: 0 }}>
            Copyright © JAC. All rights reserved.
          </p>
          <p style={{ marginBottom: 0 }}>
            Report any problems or questions to{" "}
            <a
              href="mailto:jac.form.helpdesk@gmail.com"
              style={{ textDecoration: "none", color: "white" }}
            >
              ithelp.jac@gmail.com
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default IntermediateLanding;
